import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import HamburgerMenu from './HamburgerMenu';
import { useAuth } from '../hooks/useAuth';
import './BasicAuth.css';

interface BasicAuthProps {
  children: React.ReactNode;
}

const BasicAuth: React.FC<BasicAuthProps> = ({ children }) => {
  const { t } = useLanguage();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { isAuthenticated, login, logout } = useAuth();

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();

    const result = login(username, password);
    if (result) {
      setError(result);
    } else {
      setError('');
    }
  };

  const handleLogout = () => {
    logout();
    setUsername('');
    setPassword('');
  };

  if (!isAuthenticated) {
    return (
      <div className="auth-container">
        <HamburgerMenu onLogout={() => {}} />
        <div className="auth-form">
          <h2>{t('auth.title')}</h2>
          <p>{t('auth.description')}</p>
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label htmlFor="username">{t('auth.username')}</label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">{t('auth.password')}</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            {error && <div className="error-message">{error}</div>}
            <button type="submit">{t('auth.login')}</button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div>
      <HamburgerMenu onLogout={handleLogout} />
      {children}
    </div>
  );
};

export default BasicAuth;